import { render, staticRenderFns } from "./item.vue?vue&type=template&id=4c0d931a"
import script from "./item.ts?vue&type=script&lang=js&external"
export * from "./item.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0d931a')) {
      api.createRecord('4c0d931a', component.options)
    } else {
      api.reload('4c0d931a', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=4c0d931a", function () {
      api.rerender('4c0d931a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfe/item.vue"
export default component.exports